import { CellColors } from '../model/colors.model';

export enum CourseStatusEnum {
  overdue = 'overdue',
  incomplete = 'incomplete',
  complete = 'complete',
  notStarted = 'notStarted',
  noCoursesAssigned = 'noCoursesAssigned',
  na = 'na',
}

export const courseStatusCssClass = (value: CourseStatusEnum, usesDueDates: boolean): string => {
  switch (value) {
    case CourseStatusEnum.complete:
      return CellColors.green;
    case CourseStatusEnum.incomplete:
      return CellColors.amber;
    case CourseStatusEnum.notStarted:
      return usesDueDates ? CellColors.amber : CellColors.red;
    case CourseStatusEnum.overdue:
      return CellColors.red;
    case CourseStatusEnum.noCoursesAssigned:
    case CourseStatusEnum.na:
      return CellColors.grey;
  }
};
